module.exports = __webpack_public_path__ + "static/img/manual-5.c6dd351.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-5.png
// module id = xNHK
// module chunks = 4